define([], function () {
    function config($stateProvider) {
        $stateProvider
            .state('app', {
                abstract: true,
                controller: 'TemplateCtrl',
                resolve: {
                    isTrialing: ['$stateParams', '$state', 'UserService', 'AuthService', function ($stateParams, $state, UserService, AuthService) {
                        var user = AuthService.getSessionUser();
                        return !!(user && user.canDoTrial);
                    }],
                    currentLangCode: ['$translate', function ($translate) {
                        return $translate('currentLangCode');
                    }],
                    currentUser: ['AuthService', function (AuthService) {
                        return AuthService.getSessionUser();
                    }],
                    userInfo: ['UserService', 'AuthService', '$state', function (UserService, AuthService, $state) {
                        return UserService.sessionInfo()
                            .then(function (res) {
                                var user = AuthService.getSessionUser();
                                if (res && res.data && res.data.isActive === false && user && user.email) {
                                    $state.go('access.email-verification', {
                                        token: btoa(user.email)
                                    });
                                    return null;
                                }

                                return res.data;
                            })
                            .catch(function (err) {
                                console.log(err);
                                return null;
                            });
                    }],
                    subscriptions: ['AuthService', 'SubscriptionService', function (AuthService, SubscriptionService) {
                        if (!AuthService.isAuthenticated()) {
                            return [];
                        }
                        return SubscriptionService.plans()
                            .then(function (res) {
                                return Array.isArray(res && res.data) ? res.data : null;
                            })
                            .catch(function () {
                                // Authenticated route rendering must not infer "free plan"
                                // when subscription data is temporarily unavailable.
                                return null;
                            });
                    }],
                },
                templateUrl: './app/modules/template/template.view.html'
            })
            .state('404', {
                templateUrl: './app/modules/template/404.html',
            });
    }

    config.$inject = ['$stateProvider', '$urlRouterProvider'];
    return config;
});
